import { render, staticRenderFns } from "./nxText.vue?vue&type=template&id=cd884430&scoped=true&"
import script from "./nxText.vue?vue&type=script&lang=js&"
export * from "./nxText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd884430",
  null
  
)

export default component.exports